var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgZoomPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.4 20.4a.6.6 0 1 0 1.2 0v-7.8h7.8a.6.6 0 1 0 0-1.2h-7.8V3.6a.6.6 0 1 0-1.2 0v7.8H3.6a.6.6 0 1 0 0 1.2h7.8z"
})));
export default SvgZoomPlus;